/**
 * @class {T.Form.AutoComplete}
 * @extends {T.Form.Base}
 * @param {T.Form.AutoComplete.Par|Object} [par]
 */
T.Form.AutoComplete = Class(
	/**
	 * @lends {AutoComplete#}
	 */
	{
		__NAME: 'AutoComplete',

		/** Prevent fake select triggering two change events */
		_preventDuplicate: false,
		_preventedDuplicate: false,
		/** Prevent triggering change when navigating away */
		_preventChange: false,

		/**
		 * @param {AutoComplete.Par|Object} [par]
		 * @constructs
		 */
		__construct: function ( par ) {
			par = par || {};
			let attr = {
				placeholder: par.placeholder || ''
			};
			O2O(attr, par.attr || {});

			this._onChangeEvent = par.onChange || D.doNothing;
			this._onKeyUpEvent = par.onKeyUp || D.doNothing;
			this._onKeyDownEvent = par.onKeyDown || D.doNothing;
			this._onFocusEvent = par.onFocus;
			this._onBlurEvent = par.onBlur;

			this.node = mkE({
				tag: 'div',
				className: 'input input-autocomplete',
				els: [
					{
						tag: 'label',
						onmousedown: e => {
							if( e.target !== this._input ) {
								e.preventDefault();
							}
						},
						els: [
							this._captionNode = mkE({
								tag: 'span',
								className: 'hidden'
							}),
							this._itemNode = mkE({
								tag: 'div',
								className: 'form-control',
								els: [
									this._input = mkE({
										tag: 'input',
										type: par.type || 'text',
										attr: attr,
										prop: {
											onchange: this._onChange,
											onkeyup: this._onKeyUp,
											onkeydown: this._onKeyDown,
											onfocus: this._onFocus,
											onblur: this._onBlur
										}
									}),
									par.button || ''
								]
							})
						]
					},
					this._getErrorNode(),
					this._getHelpNode()
				]
			});

			if( par.border ) {
				addClassName(this.node, 'input-border');
			}

			if( par.dark ) {
				addClassName(this.node, 'input-dark');
			}

			if( par.icon ) {
				addClassName(this.node, 'input-icon input-icon-' + par.icon);
			}

			if( par.className ) {
				addClassName(this.node, par.className);
			}

			if( par.clear ) {
				this._clearNode = mkE({
					tag: 'div',
					className: 'clear',
					onmousedown: this._clear
				}).append(this._itemNode);
				addClassName(this.node, 'input-clear');
			}

			if( par.remove ) {
				this._removeNode = mkE({
					tag: 'div',
					className: 'remove',
					onclick: par.remove
				}).append(this._itemNode);
				addClassName(this.node, 'input-remove');
			}

			this._autocomplete = false;
			this._autocompleteContainer = mkE({
				tag: 'ul',
				className: 'autocomplete'
			}).append(this._itemNode);

			this._par(par);
			this.value(par.value || null);
		},

		value: function ( v ) {
			if( isset(v) ) {
				this._input.value = v;
				this._checkClear();
			}
			return this._input.value;
		},

		focus: function () {
			this._input.focus();
		},

		blur: function () {
			this._input.blur();
		},

		showAutoComplete: function () {
			if( this._autocomplete === null || this._autocompleteContainer.children.length === 0 ) {
				return;
			}
			addClassName(this.node, 'ac-open');
			this._autocomplete = true;
		},

		hideAutoComplete: function () {
			if( this._autocomplete === null ) {
				return;
			}
			removeClassName(this.node, 'ac-open');
			this._autocomplete = false;
		},

		setAutocompleteItems: function ( items ) {
			clearNode(this._autocompleteContainer);
			if( items && items.length ) {
				for( let i = 0; i < items.length; i++ ) {
					const item = items[i];
					if( item.href ) {
						mkE({
							tag: 'li',
							els: [{
								tag: 'a',
								href: item.href,
								onclick: this._onClickLink.bind(this),
								els: [
									item.caption
								]
							}]
						}).append(this._autocompleteContainer);
					} else {
						mkE({
							tag: 'li',
							els: [{
								tag: 'a',
								onclick: this._onClickAutoCompleteItem.bind(this, item.value),
								els: [
									item.caption
								]
							}]
						}).append(this._autocompleteContainer);
					}
				}
				this.showAutoComplete();
			} else {
				this.hideAutoComplete();
			}
		},

		hasFocus() {
			return this._input === document.activeElement;
		},

		_onClickAutoCompleteItem: function ( id ) {
			this._preventDuplicate = true;
			this._preventedDuplicate = false;
			this.value(id);
			this.blur();
			this._input.dispatchEvent(new Event('change', {bubbles: true}));
		},

		_onClickLink: function () {
			this._preventChange = true;
		},

		_onFocus: function () {
			addClassName(this.node, 'input-focus');
			if( this._onFocusEvent ) {
				this._onFocusEvent(this);
			}
			this.showAutoComplete()
		},

		_onBlur: function ( e ) {
			removeClassName(this.node, 'input-focus');
			if( this._onBlurEvent ) {
				this._onBlurEvent(this);
			}
			this.hideAutoComplete();
		},

		_clear: function () {
			this.value('');
			this._onChangeEvent();
			setTimeout(this.focus, 100);
		},

		_checkClear: function () {
			if( !this._clearNode ) {
				return;
			}
			if( this._input.value ) {
				addClassName(this.node, 'input-clear-visible');
			} else {
				removeClassName(this.node, 'input-clear-visible');
			}
		},

		/** @param {Event} e */
		_onChange: function ( e ) {
			if( e.isTrusted ) {
				this._preventedDuplicate = true;
			} else if( this._preventedDuplicate ) {
				return;
			}
			if( this._preventChange ) {
				this._preventChange = false;
				return;
			}
			this._onChangeEvent(e);
			this._checkClear();
		},

		_onKeyUp: function ( e ) {
			this._onKeyUpEvent(e);
			this._checkClear();
		},

		_onKeyDown: function ( e ) {
			this._onKeyDownEvent(e);
			this._checkClear();
		}
	},
	T.Form.Base
);

/**
 * @class {AutoComplete.Par}
 * @extends {T.Form.Base.Par}
 */
T.Form.AutoComplete.Par = Class(
	/**
	 * @lends {AutoComplete.Par#}
	 */
	{
		__NAME: 'AutoComplete.Par',

		type: 'text',
		placeholder: '',
		prefix: null,
		suffix: null,
		value: null,
		attr: {},
		prop: {},
		onKeyUp: D.doNothing,
		onKeyDown: D.doNothing,
		onChange: D.doNothing,
		border: false,
		dark: false,
		icon: '',
		className: '',
		clear: false,
		button: null
	},
	T.Form.Base.Par
);
